<template lang="pug">
  e-form-group(
    :name="fieldName"
    inputType="select"
    label="Группа отходов"
    :model="fields"
    :options="options"
    :tabView="tabView"
    :formGroupStyle="formGroupStyle"
      :required="required"
  )
</template>
<script>
import reportFieldMixin from '../../mixins/report-field-mixin'
export default {
  name: 'othod_type',
  mixins: [reportFieldMixin],
  computed: {
    fieldName() {
      return 'othod_type'
    },
    options() {
      return [
        { id: 1, name: 'Все отходы' },
        { id: 2, name: 'РСО' },
        { id: 3, name: 'Элементы питания' },
        { id: 4, name: 'ТКО' },
      ]
    },
  },
  created() {
    this.$set(this.fields, this.fieldName, 1)
  },
}
</script>
